import React from 'react';
import { Field } from 'formik';
import { InputGroup } from 'reactstrap';
import FormikInputField from 'components/Fields/FormikInputField';
import LoadingButton from 'components/common/LoadingButton';

const EditProfileForm = (props) => {
  const { handleSubmit, isValid, dirty, isSubmitting, handleBlur } = props;
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <InputGroup className="mt-3" size="medium">
          <Field
            id="name"
            name="name"
            component={FormikInputField}
            label="Name"
            placeholder="Name"
            onBlur={handleBlur}
          />
        </InputGroup>

        <InputGroup className="mt-3" size="medium">
          <Field
            id="email"
            name="email"
            component={FormikInputField}
            label="Email"
            placeholder="Email"
            disabled
            onBlur={handleBlur}
          />
        </InputGroup>

        <InputGroup className="mt-3" size="medium">
          <Field
            id="phone"
            name="phone"
            component={FormikInputField}
            label="Phone"
            placeholder="Phone"
            onBlur={handleBlur}
          />
        </InputGroup>

        <InputGroup size="medium">
          <Field
            id="role"
            name="role"
            component={FormikInputField}
            label="Role"
            placeholder="Role"
            onBlur={handleBlur}
            disabled
          />
        </InputGroup>

        <InputGroup size="medium">
          <Field
            id="organization"
            name="organization"
            component={FormikInputField}
            label="Organization"
            placeholder="Organization"
            onBlur={handleBlur}
            disabled
          />
        </InputGroup>

        {/* <InputGroup size="medium">
          <Field
            id="image"
            name="image"
            type="file"
            accept=".png, .jpg, .jpeg, .svg, .jfif"
            component={FormikFileField}
            label="Profile Image"
            placeholder="Profile image"
            onBlur={handleBlur}
          />
        </InputGroup> */}

        <LoadingButton
          className="mt-2 btn btn-primary btn-block"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="primary"
          block
          type="submit"
          size="md"
        >
          Save
        </LoadingButton>
      </form>
    </div>
  );
};

export default EditProfileForm;
